import { Post } from "../utils/http.js"
import { base64Decode, domainAdaptationURL, clientKeyMap } from "@/utils/utils"

export const generateTraceId = () => {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 15)
  return `PAYMENT-WEB-SDK-${timestamp}-${random}`
}

let initParams = {}

if (process.client) {
  initParams = {
    appName: "Superweb",
    screen: window.screen.width + "*" + window.screen.height,
    signKey: "0",
    appVersion: "1.0.0",
    platform: "WEB",
    networkType: "1",
    device: "PC",
    apiVersion: "5.23.0"
  }
}

function getHeaders(initParams) {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""

  return {
    X_Merchant_Id: commonReqParams.venderId,
    X_Client_Key: clientKeyMap[commonReqParams.venderId],
    X_Request_Trace_id: generateTraceId(),
    X_Platform: initParams.platform,
    X_Local: commonReqParams["superweb-locale"],
    X_Merchant_User_Id: accountInfo ? accountInfo.custId : ""
  }
}

let baseUrl = domainAdaptationURL()
if (process.env.NODE_ENV === "production") {
  baseUrl = baseUrl + process.env.VUE_APP_MIDDLE_API
} else {
  baseUrl = process.env.VUE_APP_MIDDLE_API
}
export function calcPromotion(params) {
  return Post(
    "/middlehub/calcPromotion",
    {
      param: JSON.stringify({
        ...getHeaders(initParams),
        ...params
      })
    },
    {
      baseURL: baseUrl,
      noNeedDomainFlag: true
    }
  )
}

export function getSecretPayData(params) {
  return Post(
    "/middlehub/getSecretPayData",
    {
      param: JSON.stringify({
        ...getHeaders(initParams),
        ...params
      })
    },
    {
      baseURL: baseUrl,
      noNeedDomainFlag: true
    }
  )
}

export function calcPromotionByBindCard(params) {
  return Post(
    "/middlehub/calcPromotionByBindCard",
    {
      param: JSON.stringify({
        ...getHeaders(initParams),
        ...params
      })
    },
    {
      baseURL: baseUrl,
      noNeedDomainFlag: true
    }
  )
}

export function checkPromotion(params) {
  return Post(
    "/middlehub/checkPromotion",
    {
      param: JSON.stringify({
        ...getHeaders(initParams),
        ...params
      })
    },
    {
      baseURL: baseUrl,
      noNeedDomainFlag: true
    }
  )
}
